/**
 * Using this component for Jobs (New) Status Management
 */

/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import { isNil } from "lodash";
import StatusNoteNew from "./modals/StatusNoteNew";
import toast from "react-hot-toast";
import ToastAlert from "../toast-alert/ToastAlert";
import useModal from "../../../hooks/useModal";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../../providers/database";

const AutoSaveStatusSelector = ({
  status,
  collection,
  recId,
  jobData,
  required,
  name,
  display,
  placeholder,
  directions,
}) => {
  const [currentStatus, setCurrentStatus] = useState("");
  const [statusID, setStatusID] = useState(status);
  const [statusCollection, setStatusCollection] = useState("");
  const [mainCollection, setMainCollection] = useState(collection);

  useEffect(() => {
    if (mainCollection === "JobDetailsNewCollection") {
      setStatusCollection("JobState");
    }
  }, [mainCollection, statusCollection]);

  const { isShowing: isShowingNote, toggle: toggleNote } = useModal();

  const handleDone = (message, newStatus) => {
    toggleNote();
    if (message !== undefined) {
      toast.success(message);
    }
    if (newStatus !== undefined) {
      setStatusID(newStatus);
    }
  };

  useEffect(() => {
    setStatusID(status);
  }, [status]);

  useEffect(() => {
    if (
      !isNil(statusCollection) &&
      statusCollection !== "" &&
      !isNil(statusID) &&
      statusID !== ""
    ) {
      const activeStatusCollection = doc(db, statusCollection, statusID);
      async function fetchOptions(docRef, myStatusCollection) {
        await getDoc(docRef)
          .then(async (data) => {
            setCurrentStatus(data.data().label);
          })
          .catch((error) => {
            console.log(error);
          });
      }
      fetchOptions(activeStatusCollection, statusCollection);
    }
  }, [statusID, statusCollection]);

  return (
    <div id={name} className="relative w-full mb-4">
      <>
        {!(currentStatus === "Closed") ? <label className="text-instant-teams-teal-Main text-sm  absolute  duration-300 transform -translate-y-4 scale-75 top-4 origin-[0] left-3.5 peer-focus:text-instant-teams-blue-Main peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-4">
          {display} {" - Click to change status"}
        </label> :
          <label
            className={`absolute duration-300 transform origin-[0] top-5 left-3
    ${currentStatus === "Closed"
                ? "text-lg   mb-2 bottom-2 text-instant-teams-teal-Main -translate-y-5 scale-90"
                : "text-lg text-instant-teams-teal-Main -translate-y-4 scale-75"}
    peer-focus:text-instant-teams-blue-Main
    peer-placeholder-shown:scale-100 
    peer-placeholder-shown:translate-y-0 
    peer-focus:scale-75 
    peer-focus:-translate-y-4`}
          >
            {display} {currentStatus === "Closed" && " - Closed"}
          </label>}</>
      <input
        type="text"
        name={name}
        placeholder={placeholder}
        value={currentStatus === "Closed" ? "Renew Now " : currentStatus}
        onClick={() => {
          toggleNote();
        }}
        // disabled={currentStatus==="Closed"?true:false}
        className={` cursor-pointer form-input shadow-md rounded-md w-full pt-4 text-[17px]`}
        readOnly={true}
      />
      {isShowingNote && (
        <StatusNoteNew
          onDone={handleDone}
          collection={collection}
          id={recId}
          jobData={jobData}
          name={name}
          display={display}
          placeholder={placeholder}
          status={status}
          required={required}
          directions={directions}
          statusCollection={statusCollection}
          minLength={10}
        />
      )}
      <ToastAlert />
    </div>
  );
};

export default AutoSaveStatusSelector;
